import sanitazeHtmlOrigin from 'sanitize-html';

export function stripHtml(value) {
	return sanitazeHtmlOrigin(
		value,
		{
			allowedTags: [],
			allowedAttributes: [],
			allowedClasses: {}
		}
	);

}

export function sanitizeHtml(value) {
	return sanitazeHtmlOrigin(
		value,
		{
			allowedTags: [
				// default set
				"h3", "h4", "h5", "h6", "blockquote", "p", "a", "ul", "ol", "nl", "li", "b", "i", "strong", "em", "strike", "code", "hr", "br", "div", "table", "thead", "caption", "tbody", "tr", "th", "td", "pre", "small", "span", "img",
				// additional tags
				"dl", "dt", "dd"
			],
			allowedAttributes: {
				'img': ['src', 'alt'],
				'a': ['href', 'target'],
				'dl': ['stepperList'],
				'*': ['class', 'style', 'valign', 'width', 'title'],
			},
			parseStyleAttributes: true,
		}
	);
}
